export default "__VITE_ASSET__JFTyYYmt__"